import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeMedicinalDeviceEntity } from "../Entity/TreeNodeMedicinalDeviceEntity";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";


export class TreeNodeMedicinalProductsMedicinalDevices extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent:any, cloningNode: boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Medical Devices (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Medical Devices'
        this.items = items;

        if (this.cloningNode) {
            return;
        }
        for (const item of items || []) {
            this.children?.push(new TreeNodeMedicinalDeviceEntity(injector,item,this));
        }
    }

    override getHeaders(): string[] {
        return ['Medicinal Device'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsMedicinalDevices = new TreeNodeMedicinalProductsMedicinalDevices(this.ioc!,newParent,true, this.items);        
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }   
}